import dayjs from 'dayjs';
import { datePickerMinDateMaxDateValidate } from '../../../utils/dateUtil';
import { useAppSelector } from '../../../redux/hooks';

type ErrorDetailsType = {
  error: boolean;
  errorMessageId: string;
  errorMessage: string;
  errorIndex: number | null;
};
export type OutcomestValidationResultType = {
  outcome: ErrorDetailsType[];
  startDate: ErrorDetailsType[];
  endDate: ErrorDetailsType[];
};

export const useOutcomeValidationCheck = (): OutcomestValidationResultType => {
  const outcomeDetails = useAppSelector((state) => state.ifspOutComes.outcome);
  const ifspMeetingDate = useAppSelector(
    (state) => state.ifspClientDetails.ifspClientDetails.ifspFirstMeetingDate,
  );
  const validationResult: OutcomestValidationResultType = {
    outcome: [],
    startDate: [],
    endDate: [],
  };

  outcomeDetails.forEach((item, index) => {
    // ==========Outcome============
    if (!item.outcome) {
      validationResult.outcome.push({
        error: true,
        errorMessageId: 'IFSP.Outcomes.OutcomeRequired',
        errorMessage: 'Outcome is required',
        errorIndex: index,
      });
    }

    // ================Start Date=================
    if (datePickerMinDateMaxDateValidate(item.startDate)) {
      validationResult.startDate.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'Start Date is invalid',
        errorIndex: index,
      });
    } else if (!item.startDate) {
      validationResult.startDate.push({
        error: true,
        errorMessageId: 'IFSP.Outcomes.StartDateRequired',
        errorMessage: 'Start Date is required',
        errorIndex: index,
      });
    } else if (
      item.startDate &&
      dayjs(item.startDate).isBefore(dayjs(ifspMeetingDate))
    ) {
      validationResult.startDate.push({
        error: true,
        errorMessageId: 'IFSP.Outcomes.StartDateBeforeIfspMeetingDate',
        errorMessage: 'Start Date cannot be before IFSP Meeting Date',
        errorIndex: index,
      });
    }

    // ================== End Date=======================
    if (datePickerMinDateMaxDateValidate(item.endDate)) {
      validationResult.endDate.push({
        error: true,
        errorMessageId: 'datePickerMinDateMaxDateValidate',
        errorMessage: 'End Date is invalid',
        errorIndex: index,
      });
    } else if (
      item.startDate &&
      dayjs(item.endDate).isBefore(dayjs(item.startDate))
    ) {
      validationResult.endDate.push({
        error: true,
        errorMessageId: 'IFSP.Outcomes.EndDateBeforeStartDate',
        errorMessage: 'End Date cannot be before Start Date',
        errorIndex: index,
      });
    }
  });

  return validationResult;
};
